export default __webpack_public_path__ + "media/images/6-dogs-spaced-768ec4d37a1c0884a1bee992c8ba54b6.svg";